module.exports = __webpack_public_path__ + "static/media/expenditure-total.5c1733cb.svg";